import axios, { AxiosError } from "axios";
import { MessageBox } from 'element-ui';
import router from "@/router/index"
import { IsPC } from "@/utils/util"
const http = axios.create({
  // baseURL: "/",
  // timeout: 150000000,
  headers: {
    'Content-Type': '	application/json'
  }
});

http.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data'
  }
  return config;
},
  (error: AxiosError) => {
    console.log(error)
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  response => {
    // if (response.status === 200) {}
    const { status, data } = response
    if (status === 200) {
      const isH5 = !IsPC()
      if (data.status !== 0 && !isH5) {
        MessageBox.alert(data.message, '错误', {
          type: 'warning',
          showClose: false
        })
        if (data.status === -1000) {
          router.push('/login')
        }
        return Promise.reject()
      }
      if (isH5) {
        return response
      }
      return response.data.result
    }
    // return response;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

export default http;
